import React, { useState } from "react";
import "./HomePage.css";
import TutorialModal from "./TutorialModal";
import { useNavigate } from "react-router-dom";

function HomePage() {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ title: "", content: null, nextPage: "" });
  const [buttonPosition, setButtonPosition] = useState({ top: 0, left: 0 });

  const openTutorial = (type, event) => {
    const rect = event.target.getBoundingClientRect();
    setButtonPosition({
      top: rect.bottom + window.scrollY + 10, // sotto il bottone
      left: rect.left + rect.width / 2,        // centro del bottone
    });

    if (type === "booking") {
      setModalContent({
        title: "Tutorial Prenotazioni",
        content: (
          <p>
            In questa sezione i clienti possono prenotare un appuntamento.<br />
            Basta inserire nome, email e selezionare la data desiderata.
          </p>
        ),
        nextPage: "/booking",
      });
    } else if (type === "admin") {
      setModalContent({
        title: "Tutorial Gestione",
        content: (
          <p>
            In questa sezione l'amministratore può visualizzare e gestire le prenotazioni:<br />
            approvare, modificare o cancellare appuntamenti direttamente dal pannello.
          </p>
        ),
        nextPage: "/admin",
      });
    }
    setModalOpen(true);
  };

  const handleNext = () => {
    setModalOpen(false);
    navigate(modalContent.nextPage);
  };

  return (
    <div className="homepage">
      <header className="header">
        <div className="logo">
          <img src="logo.png" alt="MA Software Logo" />
          <span>MA Software</span>
        </div>
      </header>

      <section className="hero">
        <div className="hero-content">
          <h1>MA Software Web App</h1>
          <p>Gestisci appuntamenti in modo semplice e veloce direttamente online.</p>
          <div className="hero-buttons">
            <button className="btn primary-btn" onClick={(e) => openTutorial("booking", e)}>
              Prenotazioni
            </button>
            <button className="btn secondary-btn" onClick={(e) => openTutorial("admin", e)}>
              Gestisci Prenotazioni
            </button>
          </div>
        </div>
      </section>

      <TutorialModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onNext={handleNext}
        title={modalContent.title}
        content={modalContent.content}
        buttonPosition={buttonPosition}
      />

      <footer className="footer">
        <p>© 2025 MA Software - Tutti i diritti riservati</p>
      </footer>
    </div>
  );
}

export default HomePage;
